export function normalizeBooleanValue(value) {
  return value ?? false
}

export function normalizeIntValue(value) {
  return value ? String(value) : ''
}

export function normalizeStringValue(value) {
  return value || ''
}

export function normalizeValueAsIntArray(value) {
  return Array.isArray(value) ? value.map(normalizeIntValue) : []
}

export function normalizeValueAsObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]'
    ? value
    : {}
}
